import ApiService from 'config/apiServiceApiGateway'
import { GetProductByIdDataInterface } from '../@types/ProductMasterDetail'

export const getProductDetailApi = (productId: number) =>
  ApiService.Get<GetProductByIdDataInterface>({
    url: '/wims/internal/v1/products/:productId',
    urlParams: { productId },
  })
